import { Radio, Button, message } from "antd";
import axios from "axios";
import { useState, useContext } from "react";
import DataContext from "../../../Context/dataContext";
import pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts"; // ✅ Fixed import

pdfMake.vfs = pdfFonts.vfs; // ✅ Correct assignment

function RadioButtonComponent(props) {
  const employeeData = useContext(DataContext);
  const [category, setCategory] = useState("trial_balance_all");
  const [filter, setFilter] = useState("");

  const handleFetchData = async () => {
    const dealerCode = props.data?.dealer_code || "";
    const accountCode = props.data?.account_code || "";
    const reportDate = props.data?.report_date || "";

    try {
      const response = await axios.get(
        `${employeeData.URL}/api/v1/controldata/additional-data-report-form-credit`,
        {
          params: {
            dealer_code: dealerCode,
            account_code: accountCode,
            report_date: reportDate,
            category,
            filter,
          },
          withCredentials: true,
        }
      );

      console.log("API Response:", response.data);
      message.success("Data fetched successfully!");

      generatePDF(response.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("Failed to fetch data");
    }
  };

  const generatePDF = (data) => {
    if (!data || data.length === 0) {
      message.warning("No data available to generate PDF.");
      return;
    }

    const tableHeaders = Object.keys(data[0] || {}).map((key) => ({
      text: key.replace(/_/g, " ").toUpperCase(),
      style: "tableHeader",
      alignment: "center",
    }));

    const tableData = data.map((item) =>
      Object.values(item).map((value) => ({
        text: value ? value.toString() : "",
        fontSize: 8,
        alignment: "center",
        color: typeof value === "number" && value < 0 ? "red" : "black",
        noWrap: false,
      }))
    );

    const columnCount = tableHeaders.length;
    const columnWidths =
      columnCount > 8 ? Array(columnCount).fill("auto") : Array(columnCount).fill("*");

    const docDefinition = {
      pageSize: columnCount > 8 ? "A3" : "A4",
      pageOrientation: columnCount > 6 ? "landscape" : "portrait",
      pageMargins: [10, 20, 10, 20],
      header: {
        text: "Imax Global - 2425",
        alignment: "center",
        fontSize: 16,
        bold: true,
        margin: [0, 10, 0, 20],
      },
      footer: function (currentPage, pageCount) {
        return {
          text: `Page ${currentPage} of ${pageCount}`,
          alignment: "right",
          fontSize: 10,
          margin: [0, 0, 20, 10],
        };
      },
      content: [
        { text: "Net Due Report", style: "header" },
        { text: `Date: ${new Date().toLocaleDateString()}`, margin: [0, 0, 0, 10] },
        {
          table: {
            headerRows: 1,
            widths: columnWidths,
            dontBreakRows: true,
            body: [tableHeaders, ...tableData],
          },
          layout: "lightHorizontalLines",
        },
      ],
      styles: {
        header: { fontSize: 14, bold: true, margin: [0, 0, 0, 10] },
        tableHeader: {
          bold: true,
          fillColor: "#eeeeee",
          fontSize: 10,
          alignment: "center",
        },
      },
    };

    pdfMake.createPdf(docDefinition).download("Net_Due_Report.pdf");
  };

  return (
    <div style={{ padding: 16 }}>
      <Radio.Group value={category} onChange={(e) => setCategory(e.target.value)}>
        <Radio value="trial_balance_all">Trial Balance All</Radio>
        <Radio value="creditor">Creditor</Radio>
        <Radio value="debtor">Debtor</Radio>
        <Radio value="trial_with_cd">Trial With Debtor/Creditor</Radio>
      </Radio.Group>

      <div style={{ marginTop: 16 }}>
        <Radio.Group value={filter} onChange={(e) => setFilter(e.target.value)}>
          <Radio value="creditor_closing_balance">Credit Closing Balance</Radio>
          <Radio value="debtor_closing_balance">Debit Closing Balance</Radio>
          <Radio value="all">All</Radio>
          <Radio value="dealer_wise">Dealer Wise</Radio>
        </Radio.Group>
      </div>

      <Button type="primary" onClick={handleFetchData} style={{ marginTop: 16 }}>
        Fetch Data & Generate PDF
      </Button>
    </div>
  );
}

export default RadioButtonComponent;
